import { Controller } from "@hotwired/stimulus"

// data-controller="provider-filter"
// data-provider-filter-current-value="anthropic"
//
//   <select data-action="change->provider-filter#change">…</select>
//   <div data-provider-filter-target="section" data-provider="anthropic">…</div>
//   <div data-provider-filter-target="section" data-provider="google">…</div>
//
// Toggles visibility of provider-specific subsections based on the
// currently chosen provider. No JS framework dependencies — sets `hidden`
// on the section elements.
export default class extends Controller {
  static targets = ["section"]
  static values  = { current: String }

  connect() {
    this.applyFilter()
  }

  change(event) {
    this.currentValue = event.target.value
    this.applyFilter()
  }

  applyFilter() {
    const current = (this.currentValue || "").toString()
    this.sectionTargets.forEach((el) => {
      el.hidden = el.dataset.provider !== current
    })
  }
}
